import type { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
import './LegalLayout.css';

interface LegalLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

function LegalLayout({ title, subtitle, children }: LegalLayoutProps) {
  return (
    <div className="site">
      <Header overlay={false} />
      <main className="legal-main">
        <article className="legal-article">
          <header className="legal-header">
            <h1>{title}</h1>
            {subtitle && <p className="legal-subtitle">{subtitle}</p>}
          </header>
          <div className="legal-body">{children}</div>
        </article>
      </main>
      <Footer />
    </div>
  );
}

export default LegalLayout;
